<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :renderColumnValue="renderColumnValue"
                :rowButtonAction="rowButtonAction"
                :tooltipColumns="tooltipColumns"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <UserForm :formProps="formProps"> </UserForm>
            </template>
            <template #search="searchProps">
                <UserSearch :searchProps="searchProps"> </UserSearch>
            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref } from "vue";
import UserForm from "./UserForm.vue";
import UserSearch from "./UserSearch.vue";
import { rowButtonAction } from "@pages/Helper/crud_utils.js";
import { __, screenMessage, getFromRoute } from "@pages/Helper/utils.js";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    tooltipColumns: Object,
    initialSort: Object,
    buttonsVisibility: Object,
});

const selectedRows = ref([]);

//------------------------------------------------------------------------------

const renderColumnValue = (field, value) => {
    switch (field) {
        case "is_locked":
            return value == 1 ? '<span class="flex justify-content-center"><i class="fa-solid fa-lock" style="font-size:20px;color:red;"></i></span>' : "";
        case "is_active":
            return value == 1 ? '<span class="flex justify-content-center"><i class="fa-solid fa-person-running" style="font-size:20px;color:royalblue;"></i></span>' : "";

        default:
            return value;
    }
};

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
